var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "vip-container" }, [
    _vm.isSVip
      ? _c("span", { staticClass: "vip svip" })
      : _c("span", { staticClass: "vip", class: { active: _vm.isVip } }),
    _vm._v(" "),
    _vm.isSVip && !_vm.isVip
      ? _c(
          "span",
          {
            staticClass: "vip-operate __pointer",
            on: { click: _vm.goTradeVip }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("trade.limitPrice.cancelVip")) +
                "\n    "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "span",
      {
        staticClass: "vip-operate drop_menu __pointer",
        on: { click: _vm.goTradeVip }
      },
      [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.isVip && _vm.isSVip
                ? _vm.$t("tradeVip.title")
                : _vm.$t("tradeVip.open")
            ) +
            "\n    "
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }